import React, { createContext, useContext, useState } from "react";
import WhatsAppModal from "../components/WhatsAppFlotante/WhatsAppModal";
import useFirestoreUpdate from "./useFirestoreData";
import {
  getSavedTrackingParams,
  saveTrackingParams,
  resolveSuborigen,
  CONTACT_ENTRY,
} from "../utils/utmTracker";
import { saveUtmParams, openWhatsAppConsulta, urlSinUtmsPrincipales } from "./whatsappConfig";

const WhatsAppConsultaContext = createContext(null);

export const useWhatsAppConsulta = () => {
  const ctx = useContext(WhatsAppConsultaContext);
  if (!ctx) {
    throw new Error("useWhatsAppConsulta debe usarse dentro de WhatsAppConsultaProvider");
  }
  return ctx;
};

export const WhatsAppConsultaProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { updateData } = useFirestoreUpdate("consultas", "validaciones");

  const openConsultaForm = () => setOpen(true);

  const handleModalSubmit = async (values) => {
    setLoading(true);
    try {
      saveTrackingParams();
      saveUtmParams();
      const tracking = getSavedTrackingParams();
      const hadPrincipalUtms = !urlSinUtmsPrincipales(window.location.search);
      await updateData({
        ...values,
        contact_entry: CONTACT_ENTRY.WHATSAPP,
        SubOrigen: resolveSuborigen(
          hadPrincipalUtms ? { utm_medium: tracking.utm_medium } : { utm_medium: "" },
          CONTACT_ENTRY.WHATSAPP
        ),
        GCLID: tracking.gclid ?? "",
        ConsultaOrigenId: tracking.utm_term ?? "",
      });
      setOpen(false);
      openWhatsAppConsulta();
    } catch (error) {
      alert("Ocurrió un error al guardar los datos. Intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <WhatsAppConsultaContext.Provider value={{ openConsultaForm, loading }}>
      {children}
      <WhatsAppModal
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleModalSubmit}
        loading={loading}
      />
    </WhatsAppConsultaContext.Provider>
  );
};
